(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './ktor-ktor-io.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./ktor-ktor-io.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'rsocket-kotlin-rsocket-core-js-ir'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'rsocket-kotlin-rsocket-core-js-ir'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'rsocket-kotlin-rsocket-core-js-ir'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'rsocket-kotlin-rsocket-core-js-ir'.");
    }
    if (typeof this['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'rsocket-kotlin-rsocket-core-js-ir'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'rsocket-kotlin-rsocket-core-js-ir'.");
    }
    root['rsocket-kotlin-rsocket-core-js-ir'] = factory(typeof this['rsocket-kotlin-rsocket-core-js-ir'] === 'undefined' ? {} : this['rsocket-kotlin-rsocket-core-js-ir'], this['kotlin-kotlin-stdlib'], this['kotlinx-coroutines-core'], this['ktor-ktor-io']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_io) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var NotImplementedError = kotlin_kotlin.$_$.gd;
  var Companion_getInstance = kotlin_io_ktor_ktor_io.$_$.g;
  var BytePacketBuilder = kotlin_io_ktor_ktor_io.$_$.r;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var toString = kotlin_kotlin.$_$.ka;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.m1;
  var encodeToByteArray = kotlin_kotlin.$_$.cb;
  var toByte = kotlin_kotlin.$_$.ha;
  var writeFully = kotlin_io_ktor_ktor_io.$_$.z;
  var classMeta = kotlin_kotlin.$_$.z8;
  var toList = kotlin_kotlin.$_$.p7;
  var writeText = kotlin_io_ktor_ktor_io.$_$.b1;
  var Companion_getInstance_0 = kotlin_io_ktor_ktor_io.$_$.h;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.q1;
  //endregion
  //region block: pre-declaration
  function fireAndForget(payload, $completion) {
    payload.u3g();
    notImplemented('Fire and Forget');
  }
  function requestResponse(payload, $completion) {
    payload.u3g();
    notImplemented('Request Response');
  }
  function requestStream(payload) {
    payload.u3g();
    notImplemented('Request Stream');
  }
  setMetadataFor(RSocket, 'RSocket', interfaceMeta, VOID, [CoroutineScope], VOID, VOID, VOID, [1]);
  setMetadataFor(Reader, 'Reader', objectMeta);
  setMetadataFor(RoutingMetadata, 'RoutingMetadata', classMeta);
  function close() {
    this.r5f().u3g();
    var tmp0_safe_receiver = this.w27();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.u3g();
    }
  }
  setMetadataFor(Payload, 'Payload', interfaceMeta);
  setMetadataFor(PayloadFromBuilder, 'PayloadFromBuilder', classMeta, VOID, [Payload], PayloadFromBuilder);
  //endregion
  function RSocket() {
  }
  function notImplemented(operation) {
    throw new NotImplementedError(operation + ' is not implemented.');
  }
  function metadata(_this__u8e3s4, metadata) {
    return _this__u8e3s4.o5f(toPacket(metadata));
  }
  function toPacket(_this__u8e3s4, pool) {
    pool = pool === VOID ? Companion_getInstance().a3d() : pool;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.rsocket.kotlin.frame.io.buildPacket' call
      var builder = new BytePacketBuilder(pool);
      try {
        // Inline function 'io.rsocket.kotlin.metadata.toPacket.<anonymous>' call
        _this__u8e3s4.p5f(builder);
        tmp$ret$0 = builder.lr();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.u3g();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  function Reader() {
  }
  var Reader_instance;
  function Reader_getInstance() {
    return Reader_instance;
  }
  function RoutingMetadata(tags) {
    this.q5f_1 = tags;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.q5f_1.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.w();
      // Inline function 'io.rsocket.kotlin.metadata.RoutingMetadata.<anonymous>' call
      // Inline function 'kotlin.require' call
      var containsArg = element.length;
      // Inline function 'kotlin.contracts.contract' call
      if (!(1 <= containsArg ? containsArg <= 255 : false)) {
        // Inline function 'io.rsocket.kotlin.metadata.RoutingMetadata.<anonymous>.<anonymous>' call
        var message = "Tag length must be in range 1..255 but was '" + element.length + "'";
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
  }
  protoOf(RoutingMetadata).p5f = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.q5f_1.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.w();
      // Inline function 'io.rsocket.kotlin.metadata.RoutingMetadata.writeSelf.<anonymous>' call
      var bytes = encodeToByteArray(element);
      _this__u8e3s4.c3f(toByte(bytes.length));
      writeFully(_this__u8e3s4, bytes);
    }
  };
  function RoutingMetadata_0(tags) {
    return new RoutingMetadata(toList(tags));
  }
  function Payload() {
  }
  function data(_this__u8e3s4, value) {
    // Inline function 'io.rsocket.kotlin.payload.data' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        // Inline function 'io.rsocket.kotlin.payload.data.<anonymous>' call
        writeText(builder, value);
        tmp$ret$0 = builder.lr();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.u12();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    _this__u8e3s4.s5f(tmp$ret$0);
    return Unit_instance;
  }
  function PayloadFromBuilder() {
    this.t5f_1 = false;
    this.u5f_1 = false;
    this.v5f_1 = Companion_getInstance_0().q3g_1;
    this.w5f_1 = null;
  }
  protoOf(PayloadFromBuilder).r5f = function () {
    return this.v5f_1;
  };
  protoOf(PayloadFromBuilder).w27 = function () {
    return this.w5f_1;
  };
  protoOf(PayloadFromBuilder).s5f = function (value) {
    if (this.t5f_1) {
      value.u3g();
      // Inline function 'kotlin.error' call
      var message = 'Data already provided';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.v5f_1 = value;
    this.t5f_1 = true;
  };
  protoOf(PayloadFromBuilder).o5f = function (value) {
    if (this.u5f_1) {
      value.u3g();
      // Inline function 'kotlin.error' call
      var message = 'Metadata already provided';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.w5f_1 = value;
    this.u5f_1 = true;
  };
  protoOf(PayloadFromBuilder).lr = function () {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.t5f_1) {
      // Inline function 'io.rsocket.kotlin.payload.PayloadFromBuilder.build.<anonymous>' call
      var message = 'Data is required';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return this;
  };
  //region block: post-declaration
  protoOf(PayloadFromBuilder).u3g = close;
  //endregion
  //region block: init
  Reader_instance = new Reader();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = RoutingMetadata_0;
  _.$_$.b = metadata;
  _.$_$.c = PayloadFromBuilder;
  _.$_$.d = Payload;
  _.$_$.e = data;
  //endregion
  return _;
}));

//# sourceMappingURL=rsocket-kotlin-rsocket-core-js-ir.js.map
